
if ($('#app-strata').length) {
    var hadv = null;
    var hcamp = null;
    var save_tby_file = false;
    var save_lines = [];
    var success_data='';

    var adv_search = $('#advertiser_searchs');

    adv_search.select2({
        placeholder: "Select one..."
    });

    adv_search.on('change', function (e) {
        $('#display_campaign_ss').css("display", "none");
        $('#display_order_ss').css("display", "none");
        var adv = $("#advertiser_searchs option:selected").val();
        $("#hadv").val(adv);
        hadv = $("#advertiser_searchs option:selected").val();

        $.ajax({
            type: 'GET',
            url: '/invoices/search_campaign/' + adv,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': ''});
                $.each(data.campaigns, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name, 'title': value.name});
                });

                var adv_new = $('#campaign_searchs');
                adv_new.html('').select2({
                    'data': advertisers,
                });
                $('#display_campaign_ss').css("display", "block");
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $("#campaign_searchs").on('change', function (e) {
        $("#hcamp").val($("#campaign_searchs option:selected").val());
        hcamp = $("#campaign_searchs option:selected").val();
    });

    /**
     * Pusher
     */

   Pusher.logToConsole = true;
    var pusher = new Pusher($('meta[name="pusher-key"]').attr('content'), {
        cluster: $('meta[name="pusher-cluster"]').attr('content'),
        encrypted: true,
    });


    Dropzone.autoDiscover = false;

    var invoice_dropzone_func = function () {
        var invoice_dropzone = new Dropzone('#strate_dropzone', {
            url: "/strata/parse-strata",
            dictDefaultMessage: "Drag'n'Drop buy files here or use the 'Add Files' button below. Only SBX, SRX, SCX, SPOT or XML files are allowed. (Up to 10 files)",
            acceptedFiles: ".sbx, .srx,.xml,.scx,.SPOT,.csv",
            dictInvalidFileType: {error:"Incorrect file type. Only SBX, SRX, SCX ,SPOT, XML or CSV  files are allowed. Please try changing file extension."},
            addRemoveLinks: true,
            maxFiles: 1000,
            previewTemplate: document.getElementById('preview-template').innerHTML,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            clickable: ['#strate_dropzone', '#invoice_dropzone_add_files']
        });

        invoice_dropzone.on('sending', function (file, xhr, formData) {
            $(file.previewElement).find('div.invoice-progress').html('<i class="fa fa-fw fa-spinner fa-spin"></i> Uploading')
                .removeClass('text-info').addClass('text-primary');
        });

        invoice_dropzone.on('uploadprogress', function (file, progress, bytesSent) {
            if (progress == 100) {
                $(file.previewElement).find('div.invoice-progress').html('<i class="fa fa-fw fa-spinner fa-spin"></i> Verifying');
            }
        });

        invoice_dropzone.on('success', function (file) {
            console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^');
            console.log(file);
            var preview = $(file.previewElement);
            preview.addClass('verified');
            preview.find('div.invoice-progress').html('<i class="fa fa-check fa-fw"></i> Verified')
                .removeClass('text-primary').addClass('text-success');
            preview.find('[data-dz-remove]').attr('disabled', null);

            update_invoice_button();
        });

        invoice_dropzone.on('removedfile', function (file) {
            if (file.status == "success") {
                var file_response = $.parseJSON(file.xhr.response);
                $.ajax({
                    type: 'POST',
                    url: '/invoices/destroy/',
                    data: {
                        'id': file_response.data.id
                    },
                    dataType: 'json',
                    encode: true,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function () {
                        global_notification('success', 'Pending Invoice removed.');
                    },
                    error: function () {
                        ajax_error();
                    }
                });
            }
            update_invoice_button();
        });

        invoice_dropzone.on('error', function (file, response) {
            if(response !== 'Upload canceled.') {
                global_notification('error', '<b>ERROR</b> UPLOADING FILE <b>' + file.name + '</b>: ' + response.message);

                setTimeout(function () {
                    console.log('ERROR UPLOADING FILE: ' + file.name + ' - ' + response.message);
                }, 2000);

                invoice_dropzone.removeFile(file);
            }
            else
                global_notification('success', response);
        });

        var update_invoice_button = function () {
            var files = invoice_dropzone.getAcceptedFiles();

            var temp = true;

            $.each(files, function (index, value) {
                if (!$(value.previewElement).hasClass('verified')) {
                    temp = false;
                }

                if (temp) {
                    $('#invoice_dropzone_continue').attr('disabled', null);
                } else {
                    // File passed Verification
                    $('#invoice_dropzone_continue').attr('disabled', 'disabled');
                }
            });
        };

        $('#invoice_dropzone_continue').on('click', function () {
            $('.content-wrap').html('');
            $("#progress-content").html("");
            var files = invoice_dropzone.getAcceptedFiles();
            var ids = [];
            var count = 0;
            console.log('********************* files');
            console.log(files);

           $('.div-with-errors').html('');
            $.each(files, function (index, value) {
                count++;
                var html = '<div class="row" id="row-' + count + '" style="dislplay: none">' +
                    '<div class="m-b-10">' +
                    '<div class="col-xs-6 text-center">' +
                    '<span class="name" id="file-' + count + '"></span>' +
                    '</div>' +
                    '<div class="col-xs-6 text-left">' +
                    '<div id="progress-' + count + '"></div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<br />';
                $("#progress-content").append(html);

                console.log("response");
                console.log(value.xhr.response);
                var file_response = $.parseJSON(value.xhr.response);
                ids.push(file_response.data.id);

                $('#file-' + count).html(file_response.data.original_filename);
                $('#progress-' + count).html('<i class="fa fa-fw fa-spinner fa-spin"></i><span class="message">Queued</span></div>');
                $('#row-' + count).css('display', 'block');
            });
            $("#progress-content").css("display", "block");

            channel = pusher.subscribe('invoices', function () {
                console.log('listening on channel "invoices"');
            });

            count = 1;

           channel.bind('App\\Events\\StrataUploadProgressEvent', function (event) {
                console.log('***************************************************************************************************************');
                console.log(event);
                if (event.upload.state == 'error') {
                    $('#progress-' + count).html('<div class="progress-' + event.upload.id + '" id="progress-' + event.upload.id + '">' +
                        '<i class="fa fa-fw fa-times"></i><span class="message text-danger">' + event.upload.state + ' - ' + event.upload.state_message + '</span></div>');
                    count++;
                    $('.div-with-errors').append(event.upload.original_filename+ '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="message text-danger">' + event.upload.state + ' - ' + event.upload.state_message + '</span><br>');
                } else if (event.upload.state == 'Completed') {
                    $('#progress-' + count).html('<div class="success progress-' + event.upload.id + '" id="progress-' + event.upload.id + '">' +
                        '<i class="fa fa-fw fa-check"></i><span class="text-success">' + event.upload.state + '</span></div>');
                    count++;
                } else {
                    $('#progress-' + count).html('<div class="text-info progress-' + event.upload.id + '" id="progress-' + event.upload.id + '">' +
                        '<i class="fa fa-fw fa-spinner fa-spin"></i><span class="message">' + event.upload.state + '</span></div>');
                }
                //$('#invoice-upload-messages').append('<div id="message-'+event.upload.id+'">'+event.upload.id+'&nbsp;:<i class="fa fa-fw fa-spinner fa-spin"></i><span class="message">' + event.upload.state + '</span></div>');
            });

            $.ajax({
                type: 'POST',
                url: '/strata/match',
                data: {
                    'ids': ids,
                  //  'files': files,
                },
                dataType: 'json',
                encode: true,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    console.log('data', data);
                    if(typeof data.market_errors !== 'undefined' && data.at_least_one === true){
                        var string = ''; var last = data.tv_markets.length;
                        for(var ind in data.tv_markets)
                            string += ' ' + data.tv_markets[ind].name + ((ind !== last - 1) ? ',' : '');
                        swal({
                                title: "Error!",
                                text: "The following markets has no vendors on Galeforcemedia: " + string + ".",
                                type: "error",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Continue",
                                cancelButtonText: "Cancel",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {
                                location.reload(true);
                            });
                    }else {

                        if ($('.div-with-errors').html() != '')
                            $('.div-display-error').css('display', 'inline');
                        else
                            $('.div-display-error').css('display', 'none');
                        console.log('AJAX SUCCESS: ');
                        console.log(data);
                        $('#invoices_number').val(0);
                        var html_print = '';
                        var value_ids = '';

                        var html = '';
                        html += ' <div class="col-md-11" style="margin-top: 1%"><table class=" invoices-select-campaign-table" style="width: 93%;">';
                        html += '<tr> <th>Campaign Name </th> <th> Advertiser </th> </tr>';
                        for (var index in data['campaign_names']) {
                            html += '<tr>' +
                                '<td> ' + data['campaign_names'][index] + ' </td>';

                            html += '<td><select class="form-control full-width select2 select-adv-import" id="' + data['campaign_names'][index] + '" name="' + data['campaign_names'][index] + '" >';
                            for (var i in data['advertisers']) {
                                html += '<option value="' + data['advertisers'][i].id + '" >' + data['advertisers'][i].name + '</option>';
                            }
                            html += '</select></td>';
                            html += '</tr>';
                        }
                        html += '</table>';
                        if (data.market_matches.length == 0) {
                            $('.market_list_show_help').hide();
                            $('.market_list_show').hide();
                        } else {
                            var html2 = '';
                            html2 += ' <div class="col-md-11" style=" margin-top: 1%"><table class=" invoices-select-market-table" style="width: 93%;">';
                            html2 += '<tr> <th>Market from File </th> <th> Suggested Market </th> </tr>';
                            for (var index in data.market_matches) {
                                html2 += '<tr>';
                                html2 += '<td>' + index + '</td>';
                                var html_x = ' <select class="form-control full-width select2 select-market-import" id="' + index + '"  name="' + index + '">';
                                for (var ind in data.markets) {
                                    var selectex = '';
                                    if (data.market_matches[index] === null) {
                                    } else {
                                        //console.log('data.market_matches[index]              ' + data.market_matches[index].id +'     '+data.markets[ind].id +'     '+ data.markets[ind].name);
                                        if (data.market_matches[index].id === data.markets[ind].id)
                                            var selectex = 'selected'
                                    }
                                    console.log(selectex);
                                    html_x += '<option value="' + data.markets[ind].id + '" ' + selectex + ' >' + (data.markets[ind].type).toUpperCase() + '--- ' + data.markets[ind].name + '</option>';
                                }
                                html_x += '</select>';
                                html2 += '<td>' + html_x + '</td></tr>';
                            }
                            html2 += '</table></div>';
                            $('.market_list_show').html('');
                            $('.market_list_show').html(html2);
                            $('.market_list_show').show();
                            $('.market_list_show_help').show();
                            $('.market_list_show').find('.select-market-import').each(function () {
                                $(this).select2({
                                    placeholder: "Select one...",
                                    minimumResultsForSearch: 3
                                });
                            });
                        }
                        var html1 = '';
                        html1 += ' <div class="col-md-11" style=" margin-top: 1%"><table class=" invoices-select-vendor-table" style="width: 93%;">';
                        html1 += '<tr> <th>Vendor/Cable System from File </th> <th> Suggested Vendor </th> </tr>';
                        for (var index in data.vendor_matches.radio) {
                            html1 += '<tr>';
                            html1 += '<td>' + index + '</td>';
                            var html_x = ' <select class="form-control full-width select-vendor-import select2" id="' + index + '"  name="' + index + '">';
                            for (var ind in data.vendors_radio) {
                                var selectex = '';
                                if (data.vendor_matches.radio[index] === null)
                                    var selectex = '';
                                else {
                                    if (data.vendor_matches.radio[index].id === data.vendors_radio[ind].id)
                                        var selectex = 'selected'
                                }
                                html_x += '<option value="' + data.vendors_radio[ind].id + '" ' + selectex + ' >' + data.vendors_radio[ind].name + '</option>';
                            }

                            html_x += '</select>';
                            html1 += '<td>' + html_x + '</td></tr>';
                        }
                        for (var index in data.vendor_matches.television) {
                            html1 += '<tr>';
                            html1 += '<td>' + index + '</td>';
                            var html_x = ' <select class="form-control full-width select-vendor-import" id="' + index + '"  name="' + index + '">';
                            for (var ind in data.vendors_tv) {
                                var selectex = '';
                                if (data.vendor_matches.television[index] === null)
                                    var selectex = '';
                                else {
                                    if (data.vendor_matches.television[index].id === data.vendors_tv[ind].id)
                                        var selectex = 'selected'
                                }
                                html_x += '<option value="' + data.vendors_tv[ind].id + '" ' + selectex + ' >' + data.vendors_tv[ind].name + '</option>';
                            }

                            html_x += '</select>';
                            html1 += '<td>' + html_x + '</td></tr>';
                        }
                        html1 += '</table></div>';
                        for (var i in data.uploads_ids)
                            value_ids += '_' + data.uploads_ids[i];
                        $('#uploads_ids').val(value_ids);
                        $('.invoices_list_show').html('');
                        $('.invoices_list_show').html(html);
                        $('.vendor_list_show').html('');
                        $('.vendor_list_show').html(html1);
                        $('.invoices_list_show').find('.select-adv-import').each(function () {
                            $(this).select2({
                                placeholder: "Select one...",
                                minimumResultsForSearch: 3
                            });
                        });
                        $('.vendor_list_show').find('.select-vendor-import').each(function () {
                            $(this).select2({
                                placeholder: "Select one...",
                                minimumResultsForSearch: 3
                            });
                        });
                        $('#InvSelectCampaignAdv').modal({backdrop: 'static', keyboard: false})
                        $('#InvSelectCampaignAdv').modal('show');
                        $('#invoice_import_tab1').removeClass('tab-current');
                        $('#invoice_import_tab2').addClass('tab-current');
                        $('#invoice_upload').removeClass('content-current');
                        $('#invoice_process').addClass('content-current');
                    }
                },
                error: function (xhr) {
                    console.log(xhr);
                    console.log('AJAX ERROR: ' + xhr.responseText);
                    debug(xhr.responseText);
                    ajax_error();
                    global_notification('error', 'All Invoices Could Not Be Imported!' + xhr.responseText);
                    $('.content-wrap').html('');
                    /*  setTimeout(function () {
                          location.reload();
                          0
                      }, 2000)
                      */
                }
            });
            //}
        });
    };

    $('#send_finish_strata_').on('click', function () {
        var html = '';
        var i = 0;
        $('.invoices_list_show').find('.select-adv-import').each(function () {
            if (typeof $(this).children("option:selected").val() !== 'undefined' && $(this).children("option:selected").val() != '') {
            } else {
                if (i == 0)
                    html += $(this).attr('data-upload');
                else
                    html += ', ' + $(this).attr('data-upload');
                i++;
            }
        });
        if (html != '') {
            swal({
                    title: "Warning!",
                    text: "The fallowing file(s) will not be imported: " + html + ". Do you want to continue? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var array = $('#invoice_camp_adv_form').serializeArray();
                        show_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: array,
                            url: '/strata/import/finalize/process',
                            dataType: "json",
                            encode: true,
                            success: function (data) {
                                global_notification('success', 'File(s) Imported.');
                                hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                setTimeout(function () {
                                    location.reload();
                                }, 1000);

                            },
                            error: function (xhr) {
                                hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });

                    }
                });
        } else {
            swal({
                    title: "Warning!",
                    text: "Are you sure you want to continue?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var array = $('#invoice_camp_adv_form').serializeArray();
                        show_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: array,
                            url: '/strata/import/finalize/process',
                            dataType: "json",
                            encode: true,
                            success: function (data) {
                                global_notification('success', 'File(s) Imported.');
                                hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                setTimeout(function () {
                                    location.reload();
                                }, 1000);

                            },
                            error: function (xhr) {
                                hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });

                    }
                });
        }
    });
    $('#InvSelectCampaignAdv').on('hide.bs.modal', function (e) {
        if (!modal_hided) {
            e.stopPropagation();
            e.preventDefault();
            swal({
                    title: "Warning!",
                    text: "Are you sure you want to exit?\nNo File(s) will be imported.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $('#InvSelectCampaignAdv').modal('hide');
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                });
        }
    })

    $(document).ready(function () {
        invoice_dropzone_func();
        $('#invoice_finish').on('click', function () {

            setTimeout(function () {
                location.reload();
            }, 1000);

        });
    });

    var invoice_match_modal = function (el) {
        var upload_id = $(el).attr('data-invoice-id');
        var modal = $('#invoice_match');
        modal.find('input[name="invoice_upload_id"]').val(upload_id);
        modal.find('select[name="invoice_campaign_id"]').html('').append('<option value=""></option>')

        $.ajax({
            type: 'GET',
            url: '/campaigns/all',
            dataType: 'json',
            success: function (data) {
                $.each(data, function (index, value) {
                    modal.find('select[name="invoice_campaign_id"]').append('<optgroup label="' + value.name + '">');
                    $.each(value['campaigns'], function (index, value) {
                        modal.find('select[name="invoice_campaign_id"]').append('<option value="' + value.id + '">' + value.name + "</option>");
                    });
                    modal.find('select[name="invoice_campaign_id"]').append("</optgroup>");
                    modal.find('button.invoice_campaign_match').unbind('click').bind('click', function () {
                        modal_match_campaign(this);
                    });
                    modal.modal("show");
                });
            }
        });
    };

    var modal_match_campaign = function (el) {
        var modal = $(el).closest('.modal');

        var data = {
            'invoice_upload_id': modal.find('input[name="invoice_upload_id"]').val(),
            'campaign_id': modal.find('select[name="invoice_campaign_id"]').val()
        };

        $.ajax({
            type: 'POST',
            url: '/invoices/match',
            data: data,
            dataType: 'json',
            encode: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                modal.modal("hide");
                global_notification('success', 'Invoices matched with campaign successfully.');
            }
        });
    };

}
